export default __webpack_public_path__ + "static/media/logo-BPO.6836e564.png";